var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['alert', {[`alert-${_vm.type}`]: _vm.type}]},[(_vm.icon)?_c('div',{staticClass:"flex-no-shrink"},[_c('svgicon',{staticClass:"w-6 h-6 mr-2",attrs:{"name":_vm.icon}})],1):_vm._e(),_vm._v(" "),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }